module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/flow_img02-89658b24459839d4d15dd8f9cc26ad39.svg";